// material
import {Box, Container, Grid} from '@mui/material';
// components
import Page from '../components/Page';
import * as React from "react";
import Typography from "@mui/material/Typography";
import {useNavigate, useParams} from "react-router-dom";
import * as CommunicationService from "../services/CommunicationService";
import {Helmet} from "react-helmet-async";
import {useEffect} from "react";
import {createCheckoutSession, checkoutScopeForOrder} from '../services/CheckoutSession';
import OrderDetailsTable from "./OrderDetailsTable";
import {linkOrderToTracking, reportBrowserPurchase, whenConsentKnown} from '../services/tracking/MarketingTracking';


// ----------------------------------------------------------------------

// One payment check per order per page load. The effect below can run more than once for the same order
// (seen in production, ~0.5 s apart); a second check only finds the order already confirmed, and the first,
// successful answer was then discarded together with the browser conversion and the order link.
const confirmations = new Map();

function confirmOnce(orderId, orderCode) {
    const key = `${orderId}/${orderCode}`;
    if (!confirmations.has(key)) {
        confirmations.set(key, {request: CommunicationService.confirmPayment(orderId, orderCode), tracked: false});
    }
    return confirmations.get(key);
}

/** For tests only. */
export function resetPaymentConfirmationsForTests() {
    confirmations.clear();
}


export default function PaymentRedirect({checkoutBasePath = '', checkoutScope = 'legacy'}) {
    let {orderId, orderCode} = useParams();

    let [orderObjectFromServer, setOrderObjectFromServer] = React.useState({
        expertVerification: false,
        phoneNumber: "",
        price: "",
        regime: "",
        userFirstName: "",
        userLastName: "",
        username: "",
    });
    let [text, setText] = React.useState("Se confirmă plata, vă rugăm așteptați!");
    const navigate = useNavigate();

    useEffect(() => {
        let active = true;
        let timer;
        const sessions = {
            legacy: createCheckoutSession('legacy'),
            comenzi: createCheckoutSession('comenzi')
        };
        const confirmation = confirmOnce(orderId, orderCode);
        confirmation.request
            .then(response => {
                if (!active) return;
                setOrderObjectFromServer({...response, expertVerification: response.expertVerification === true ? 'Da' : 'Nu'});
                const responseScope = checkoutScopeForOrder(response, checkoutScope);
                setText(response.message);
                if (!confirmation.tracked) {
                    confirmation.tracked = true;
                    // Payment confirmed by the backend: browser conversion with the server price, once Cookiebot
                    // has answered (marketing consent only). The backend reports the same order (same
                    // transaction id) server-side; Google merges both.
                    whenConsentKnown().then(() => reportBrowserPurchase({
                        orderId,
                        value: response.price,
                        email: response.username,
                        phone: response.phoneNumber,
                        code: orderCode
                    }));
                    linkOrderToTracking(orderId, {code: orderCode});
                }
                timer = window.setTimeout(() => {
                    if (!active) return;
                    sessions[responseScope].resetSession(orderId);
                    navigate(responseScope === 'comenzi' ? '/comenzi/' : '/');
                }, 10000);
            })
            .catch(error => {
                if (!active) return;
                // A failed confirmation must not discard a resumable order.
                let message = error.message;
                try { message = JSON.parse(error.message).message || message; } catch (_) { /* plain error */ }
                setText(message);
            });
        return () => {
            active = false;
            window.clearTimeout(timer);
        };
    }, [orderId, orderCode, checkoutScope, navigate]);

    return (
        <Page title="Cazier Judiciar Online – Eliberare Cazier Fara Deplasari">
            <Helmet>
                <meta name="googlebot" content="noindex"/>
                <meta name="robots" content="noindex"/>


            </Helmet>
            <Container maxWidth="xl">
                <Grid container spacing={5} align={"center"}>


                    <Grid item xs={12} md={12} lg={12}>
                        <Typography component="div" variant="h3" style={{marginTop: '2%'}}>
                            {text}
                        </Typography>

                        <Box sx={{minWidth: 240,
                            background: 'white',
                            maxWidth: {xs: '95%', sm: '60%'},
                            border: '1px solid black', borderRadius: '10px', padding: '15px', marginTop: '2%'}}>

                            <OrderDetailsTable orderObjectFromServer={orderObjectFromServer}/>
                        </Box>
                        <Typography component="div" variant="h3" style={{marginTop: '2%'}}>
                            Veți fi redirectat pe pagina principală în 5 secunde ...
                        </Typography>
                    </Grid>

                </Grid>
            </Container>
        </Page>
    );
}
